<template>
    <VJoyDialog
        ref="loginToERPDialog"
        open
        pattern-confirm
        :cancel-text="t('generic.form.cancel.label')"
        @dialog:confirm="loginViaERP"
        @dialog:hide="emit('close:dialog')"
    >
        <template #dialog-header>
            {{ t('projectclient.expenses.page.punchout.title', [erpName]) }}
        </template>
        <template #dialog-body>
            <VJoyHighlight level="info" display-icon>
                {{ t('projectclient.expenses.page.punchout.highlight', [erpName]) }}
            </VJoyHighlight>
            <p>
                {{ t('projectclient.expenses.page.punchout.description', [erpName]) }}
            </p>
            <p class="projectLinkCopier">
                <VJoyInput name="projectLink" :model-value="projectUrl" disabled size="small"></VJoyInput>
                <VJoyButton
                    :label="t('projectclient.expenses.page.punchout.button.copy.project.link')"
                    size="small"
                    @click="copyToClipboard"
                ></VJoyButton>
            </p>
        </template>
        <template #dialog-confirm>
            <VJoyButton variant="main" :label="t('projectclient.expenses.page.punchout.button.login', [erpName])" @click="loginViaERP" />
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {useTemplateRef} from 'vue';
    import {useClipboard} from '@vueuse/core';
    import {useTranslation} from '#imports';
    import {VJoyButton, VJoyDialog, VJoyHighlight, VJoyInput} from '@maltjoy/core-vue';

    const {t} = useTranslation();
    const {copy} = useClipboard();

    const props = defineProps<{
        erpName: string;
        erpUrl: string;
        projectUrl: string;
    }>();

    const emit = defineEmits<{
        'confirm:action': [];
        'close:dialog': [];
    }>();

    const loginToERPDialog = useTemplateRef('loginToERPDialog');

    function loginViaERP() {
        window.location.href = props.erpUrl;
    }

    function copyToClipboard() {
        copy(props.projectUrl);
    }
</script>

<style lang="scss" scoped>
    :deep(.joy-textarea_wrapper) {
        margin-top: var(--joy-core-spacing-4);
    }

    .projectLinkCopier {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        gap: var(--joy-core-spacing-4);

        :deep(.joy-input--small) {
            flex: 1 1 auto;
        }
    }
</style>
